import { useGetApiDataPrivacyLatestQuery } from '@lib/api';
import { LoadingComponent } from '@lib/ui';
import MDEditor from '@uiw/react-md-editor';
import { useTranslation } from 'react-i18next';

export const LatestDataPrivacyRoute = () => {
  const { t } = useTranslation('dev');
  const { data, isLoading } = useGetApiDataPrivacyLatestQuery();
  return (
    <div className="w-full max-w-2xl text-white px-4">
      <h1 className="text-md mt-16 opacity-75 capitalize">{t('data_agreements.data_privacy.title')}</h1>
      <h2 className="font-bold text-4xl mb-16 whitespace-pre-line">{t('data_agreements.data_privacy.sub_heading')}</h2>

      <LoadingComponent isLoading={isLoading} />
      <div className="bg-gray-50 rounded-xl shadow-lg border border-gray-200 p-6 text-[#454545] mb-16">
        <div data-color-mode="light" className="data-agreement-markdown">
          <MDEditor.Markdown source={data?.content} />
        </div>
      </div>
    </div>
  );
};
